module.exports = "/_next/static/resources/plant-packaging-26e317988a29410a564fbc55f30759f0.mp4";